import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";

// Pages
import LandingPage from "./pages/LandingPage";
import SearchPage from "./pages/SearchPage";
import PractitionerProfilePage from "./pages/PractitionerProfilePage";
import BookingPage from "./pages/BookingPage";
import AuthPage from "./pages/AuthPage";
import PractitionerSignup from "./pages/PractitionerSignup";
import ClientDashboard from "./pages/ClientDashboard";
import PractitionerDashboard from "./pages/PractitionerDashboard";
import PractitionerSetup from "./pages/PractitionerSetup";
import AboutPage from "./pages/AboutPage";
import AdminBackoffice from "./pages/AdminBackoffice";
import AdminBlogManagement from "./pages/AdminBlogManagement";
import AdminStripeManagement from "./pages/AdminStripeManagement";
import AdminShopPage from "./pages/AdminShopPage";
import PracticalInfoPage from "./pages/PracticalInfoPage";
import ResourcesPage from "./pages/ResourcesPage";
import BlogPage from "./pages/BlogPage";
import UnePage from "./pages/UnePage";
import ShopPage from "./pages/ShopPage";
import ShopSuccessPage from "./pages/ShopSuccessPage";
import AriaPage from "./pages/AriaPage";
import AriaChatPage from "./pages/AriaChatPage";
import CGUPage from "./pages/CGUPage";
import CGVPage from "./pages/CGVPage";
import PrivacyPage from "./pages/PrivacyPage";
import VideoCallPage from "./pages/VideoCallPage";

import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-background">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/practical-info" element={<PracticalInfoPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/une" element={<UnePage />} />
              <Route path="/boutique" element={<ShopPage />} />
              <Route path="/boutique/success" element={<ShopSuccessPage />} />
              <Route path="/aria" element={<AriaPage />} />
              <Route path="/aria/chat" element={<AriaChatPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/practitioner/:id" element={<PractitionerProfilePage />} />
              <Route path="/booking/:id" element={<BookingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/devenir-praticien" element={<PractitionerSignup />} />
              <Route path="/client/dashboard" element={<ClientDashboard />} />
              <Route path="/practitioner/dashboard" element={<PractitionerDashboard />} />
              <Route path="/practitioner/setup" element={<PractitionerSetup />} />
              <Route path="/admin" element={<AdminBackoffice />} />
              <Route path="/admin/blog" element={<AdminBlogManagement />} />
              <Route path="/admin/stripe" element={<AdminStripeManagement />} />
              <Route path="/admin/shop" element={<AdminShopPage />} />
              <Route path="/cgu" element={<CGUPage />} />
              <Route path="/cgv" element={<CGVPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/video/:roomId" element={<VideoCallPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
